import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useDispatch, useSelector} from 'react-redux';
import {ERROR_CODES} from 'src/components/authentication/errors';
import {CONSTANTS} from 'src/components/authentication/contants';
import {userResetPassword} from 'src/action-creators/referrer-portal/authentication';

import {PasswordInstruction} from 'src/components/referrer-portal/authentication/signup/sign-up';
import PasswordConfirmation from 'src/components/authentication/common/password-confirmation/password-confirmation';
import {
  Button,
  TitleMedium,
  InContextAlert,
} from '@spaced-out/ui-design-system/lib/components/index';
import ResetConfirmation from 'src/components/authentication/reset/reset-confirmation';

import css from 'src/components/authentication/reset/reset-password.css';
import formCss from 'src/components/authentication/main.css';


const ResetPasswordContainer = () => {
  const dispatch = useDispatch();
  const {t, makeKey} = useLabelTranslation();

  const [passwordStrength, setPasswordStrength] = React.useState(0);
  const [newPassword, setNewPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [isResetSuccess, setIsResetSuccess] = React.useState(false);
  const [isResetInProgress, setIsResetInProgress] = React.useState(false);

  const resetPasswordError =
    useSelector((state) => state.referrerPortal.reset_password_error) || '';

  const params = new URLSearchParams(window.location.search);
  const token = params.get('reset_id');

  const isError = passwordStrength < 3 || newPassword !== confirmPassword;

  const handlePasswordReset = async () => {
    if (!token) {
      return;
    }
    const payload = {
      reset_id: token,
      new_password: newPassword,
      new_password_copy: newPassword,
    } as const;

    setIsResetInProgress(true);
    await dispatch(userResetPassword(payload))
      .then((response) => {
        if (response) {
          setIsResetSuccess(true);
        }
      })
      .finally(() => setIsResetInProgress(false));
  };

  return (
    <div className={formCss.contentSideBar}>
      {!isResetSuccess ? (
        <div className={formCss.containerContent}>
          <div className={css.resetSection}>
            <>
              <TitleMedium>
                {t(
                  makeKey(CONSTANTS.RESET_PASSWORD_PAGE_TITLE),
                  CONSTANTS.RESET_PASSWORD_PAGE_TITLE,
                )}
              </TitleMedium>
              <PasswordInstruction />
              <div
                className={
                  token
                    ? css.passwordConfirmationToken
                    : css.passwordConfirmationSignedIn
                }
              >
                <PasswordConfirmation
                  passwordLabel={t('New_password', 'New password')}
                  passwordPlaceholder={t('Enter_password', 'Enter password')}
                  confirmPasswordLabel={t(
                    'Confirm_password',
                    'Confirm password',
                  )}
                  confirmPasswordPlaceholder={t(
                    'Repeat_password',
                    'Repeat password',
                  )}
                  setPasswordStrengthValue={setPasswordStrength}
                  setNewPasswordValue={setNewPassword}
                  setConfirmPasswordValue={setConfirmPassword}
                />
              </div>
              <Button
                size="medium"
                type="primary"
                classNames={{wrapper: css.setNewBtn}}
                disabled={isError}
                onClick={handlePasswordReset}
              >
                {isResetInProgress
                  ? t('Setting_new_password', 'Setting new password')
                  : t('Set_new_password', 'Set new password')}
              </Button>
              {!token && (
                <InContextAlert
                  semantic="danger"
                  classNames={{wrapper: css.alert}}
                >
                  {t(
                    makeKey(CONSTANTS['RESET_PASSWORD_DISABLED_ALERT']),
                    CONSTANTS['RESET_PASSWORD_DISABLED_ALERT'],
                  )}
                </InContextAlert>
              )}
              {resetPasswordError && (
                <InContextAlert
                  semantic="danger"
                  classNames={{wrapper: css.alert}}
                >
                  {/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly InvalidLoginAttempt: "Incorrect email or password"; readonly ServerError: "Failed to perform action, Please try after sometime"; readonly IncorrectOTP: "Invalid OTP entered"; ... 13 more ...; readonly InvalidReferrerEmail: "Invalid Referrer Email"; }'. */}
                  {ERROR_CODES[resetPasswordError] || resetPasswordError}
                </InContextAlert>
              )}
            </>
          </div>
        </div>
      ) : (
        <div className={formCss.containerContentCentreAligned}>
          <ResetConfirmation />
        </div>
      )}
    </div>
  );
};

export default ResetPasswordContainer;
